/**
 * @generated SignedSource<<3e7cfa508ac314cb951de5badd3b4124>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsLanding_item$data = {
  readonly title: string | null;
  readonly isSold: boolean | null;
  readonly isListingNotListed: boolean | null;
  readonly isListingUnlisted: boolean | null;
  readonly seller: {
    readonly isInternal: boolean | null;
    readonly isAccessible: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedUnpurchasableHeader_item" | "PdpRespSimilarItemsContainer_item">;
  readonly " $fragmentType": "PdpRespSimilarItemsLanding_item";
};
export type PdpRespSimilarItemsLanding_item$key = {
  readonly " $data"?: PdpRespSimilarItemsLanding_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsLanding_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingNotListed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingUnlisted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedUnpurchasableHeader_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsContainer_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "982e029fa8ae4dc903cb4a23cd438dcf";

export default node;
